/**
 * 从注册/登录接口返回的 member 对象构建 AuthContext 用的 profile（兼容 id / memberId）。
 */
export function buildAuthProfileFromMember(member, fallback = {}) {
  if (!member || typeof member !== 'object') {
    return { ...fallback };
  }

  const memberId =
    member.id ??
    member.memberId ??
    member.userId ??
    member.member_id ??
    fallback.id;
  const workerId = member.workerId ?? fallback.workerId;
  const isWorker =
    workerId != null && workerId !== undefined && workerId !== '' && Number(workerId) > 0;

  const shopRaw = member.shopId ?? member.shop_id ?? fallback.shopId ?? fallback.shop_id;

  const profile = {
    id: memberId != null && memberId !== '' ? memberId : fallback.id,
    phone: member.phone ?? fallback.phone ?? '',
    nickname:
      member.nickName ||
      member.nickname ||
      member.name ||
      fallback.nickname ||
      fallback.nickName ||
      'Tao-go Member',
    lastLoginTime: member.lastLoginTime ?? fallback.lastLoginTime,
    isWorker: isWorker ? 1 : 0,
  };

  if (shopRaw !== null && shopRaw !== undefined && shopRaw !== '') {
    const sid = Number(shopRaw);
    if (Number.isFinite(sid)) {
      profile.shopId = sid;
    }
  } else if (fallback.shopId != null && fallback.shopId !== '') {
    const sid = Number(fallback.shopId);
    if (Number.isFinite(sid)) {
      profile.shopId = sid;
    }
  }

  return profile;
}

/** 解析 {@code yc_register_ws} / {@code yc_login_ws} 等返回体 */
export function parseWsAuthResult(result, extraFallback = {}) {
  if (!result || typeof result !== 'object') {
    return {
      member: null,
      token: null,
      profile: buildAuthProfileFromMember(null, extraFallback),
    };
  }
  const nested = result.data && typeof result.data === 'object' ? result.data : null;
  const token =
    result.token ??
    result.loginToken ??
    nested?.token ??
    nested?.loginToken ??
    null;
  const member =
    result.member ??
    nested?.member ??
    (token == null && result.id != null ? result : null);
  const profile = buildAuthProfileFromMember(member, extraFallback);
  return { member, token, profile };
}
